
/* injects from baggage-loader */

'use strict';

import AccountSettingsConnectedAccountsController from './account.settings.connected-accounts.controller';
import AccountSettingsConnectedAccountsTemplate from './account.settings.connected-accounts.html';

export default class AccountSettingsConnectedAccountsComponent {
		constructor() {
				this.templateUrl = AccountSettingsConnectedAccountsTemplate;
				this.controller = AccountSettingsConnectedAccountsController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					integrations: '<'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/account/settings/connected-accounts/account.settings.connected-accounts.component.js